module.exports = __webpack_public_path__ + "img/Olympiacos.74051521.png";